import Toast from "@/plugins/Toast";
import { ToastType } from "@/types/toast";
import { inject, ref } from "vue";

interface StaticAccount {
  banco: string;
  cuenta: string;
  cci: string;
  logo: string;
  bgClass: string;
}

export default class AccountsDialogViewModel {
  public toast: Toast;
  public dialog = ref(false);
  public accounts = ref<StaticAccount[]>([
    {
      banco: "Banco de la Nación",
      cuenta: "00 - 015 - 100540",
      cci: "018 - 015 - 000015100540 - 82",
      logo: require("@/assets/images/banco-nacion.png"),
      bgClass: "bg-nacion",
    },
    {
      banco: "Scotiabank",
      cuenta: "0001446525",
      cci: "009 - 214 - 000001446525 - 86",
      logo: require("@/assets/images/scotiabank.png"),
      bgClass: "",
    },
    {
      banco: "BCP",
      cuenta: "191 - 7322246 - 0 - 79",
      cci: "002 191 007322246079 59",
      logo: require("@/assets/images/bcp.png"),
      bgClass: "bg-bcp",
    },
  ]);

  constructor() {
    this.toast = inject("toast") as Toast;
  }

  /**
   * Método para abrir el diálogo
   */
  public openDialog() {
    this.dialog.value = true;
  }

  /**
   * Método para copiar los datos de una cuenta
   * @param account - Cuenta seleccionada
   */
  public copyAccount(account: StaticAccount) {
    const textToCopy = `${account.banco}\nCuenta: ${this.removeGuion(
      account.cuenta
    )}\nCCI: ${this.removeGuion(account.cci)}`;

    navigator.clipboard
      .writeText(textToCopy)
      .then(() => {
        console.log("Datos copiados al portapapeles");
        this.toast.showToast(
          "Cuenta copiada en el portapapeles. Ctrl + V para pegar el contenido",
          ToastType.Success
        );
      })
      .catch((error) => {
        console.error("Error al copiar el texto al portapapeles:", error);
      });
  }

  /**
   * Remueve guiones y espacios de la cuenta
   */
  private removeGuion(cta: string): string {
    if (cta != null) {
      return cta.replace(/-/g, "").replace(/ /g, "");
    }
    return "";
  }

  public closeDialog() {
    this.dialog.value = false;
  }
}
